import batchHandleUrl from '../../../utils/url-handle'
const userApi = {
  // 组织 懒加载
  orgLazyLoadList: {
    url: '/pur/apaas/department/getByPid',
    type: 'get'
  },
  // 组织 查询
  orgFilter: {
    url: '/apaas/department/tree',
    type: 'post'
  },
  // 通过id查组织
  departmentListByIdsOrCodes: {
    url: '/apaas/department/listByIdsOrCodes',
    type: 'post'
  }
}

export default batchHandleUrl(userApi)
